
import { defineComponent } from "vue";
import Icon from "./../../components/controls/Icon.vue";
import mixin from "./../../mixin";

export default defineComponent({
    components: {
        Icon,
    },
    mixins:[
       mixin,
    ],
})
